export const TIME_12H_REGEX = /^(0?[1-9]|1[0-2]):[0-5]\d\s?(AM|PM)$/i;

/** "1330" -> "01:30 PM". Empty/invalid input yields "". */
export const format24hTo12h = (
  startTime: string | null | undefined,
): string => {
  if (!startTime) return '';
  const hh24 = +startTime.slice(0, 2);
  const mm = startTime.slice(2);
  const mer = hh24 < 12 ? 'AM' : 'PM';
  const hh12 = ((hh24 + 11) % 12) + 1;
  return `${String(hh12).padStart(2, '0')}:${mm} ${mer}`;
};

/** "01:30 PM" -> "1330". Unparseable input yields "". */
export const parse12hTo24h = (val: string): string => {
  const [, hh, mm, mer] = val.match(/(\d{1,2}):(\d{2})\s?(AM|PM)/i) || [];
  if (!hh) return '';
  let h = Number(hh) % 12;
  if (mer.toUpperCase() === 'PM') h += 12;
  return `${String(h).padStart(2, '0')}${mm}`;
};
